module.exports = __webpack_public_path__ + "static/media/undraw_video_call_kxyp.eecb3a51.svg";